import classes from './TextCell.module.css'
import { phoneFormat } from '../../../lib/script'

import classesCell from './BodyCell.module.css'

const PhoneBox = ({data}) => {    
    return <div className={`${classes.text_cell} ${classesCell.body_cell}`}>
        {data && <a href={`tel:${data}`}>{phoneFormat(data)}</a>}
    </div>
}

export default PhoneBox